"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto p-4" };
const _hoisted_2 = { class: "text-2xl pl-5 my-5 font-bold uppercase" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-eye" }, null, -1);
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const vue_router_1 = require("vue-router");
const toastStore_1 = require("../../stores/toast/toastStore");
const debounce_1 = __importDefault(require("lodash/debounce"));
const securityStore_1 = require("../../stores/security/securityStore");
const quotationStore_1 = require("../../stores/quotation/quotationStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'QuotationList',
    setup(__props) {
        var _a, _b, _c, _d;
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const quotationStore = (0, quotationStore_1.useQuotationStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const sortBy = (0, vue_3.ref)("createdDate");
        const sortDesc = (0, vue_3.ref)(true);
        const quotationFields = (0, vue_3.ref)([
            {
                key: "quotationId",
                label: (_a = (0, i18n_1.trans)("quotation_id", "Quotation ID", "quotation_list")) !== null && _a !== void 0 ? _a : "Quotation ID",
                value: "quotationId",
                sortable: true,
                filterable: true
            },
            {
                key: "endUserName",
                label: (_b = (0, i18n_1.trans)("end_user_name", "End-user name", "quotation_list")) !== null && _b !== void 0 ? _b : "End-user name",
                value: "endUserName",
                sortable: true,
                filterable: true
            },
            {
                key: "createdDate",
                label: (_c = (0, i18n_1.trans)("created_date", "Created date", "quotation_list")) !== null && _c !== void 0 ? _c : "Created date",
                value: "createdDate",
                sortable: true
            },
            {
                key: "validationDate",
                label: (_d = (0, i18n_1.trans)("validation_date", "Validation date", "quotation_list")) !== null && _d !== void 0 ? _d : "Validation date",
                value: "validationDate",
                sortable: true
            },
            {
                key: "actions",
                label: ""
            }
        ]);
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const quotationQuery = (0, vue_3.computed)(() => {
            var _a, _b, _c;
            let filters = {};
            quotationFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            if (((_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.customer.id) !== null && ((_b = currentUser.value) === null || _b === void 0 ? void 0 : _b.customer.id) !== "") {
                filters = { ...filters, "customer.id": (_c = currentUser.value) === null || _c === void 0 ? void 0 : _c.customer.id };
            }
            let order = `order[${sortBy.value}]`;
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                [order]: sortDesc.value ? "desc" : "asc",
                ...filters,
            };
        });
        (0, vue_3.onMounted)(() => {
            getQuotations();
        });
        (0, vue_3.onUnmounted)(() => {
            quotationStore.resetState();
        });
        const getQuotations = async () => {
            try {
                await quotationStore.getQuotations(router, quotationQuery.value);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const debouncedGetQuotations = (0, debounce_1.default)(() => {
            getQuotations();
        }, 300);
        const viewPdf = (item) => {
            quotationStore.viewPdf(router, item.quotationId);
        };
        (0, vue_3.watch)(() => quotationQuery.value, () => {
            debouncedGetQuotations();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("quotation_list", "Quotation List", "quotation_list")), 1),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: quotationFields.value,
                    "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((quotationFields).value = $event)),
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event) => ((page).value = $event)),
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[3] || (_cache[3] = ($event) => ((sortDesc).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[4] || (_cache[4] = ($event) => ((itemsPerPage).value = $event)),
                    items: (0, vue_2.unref)(quotationStore).quotations,
                    "is-busy": (0, vue_2.unref)(quotationStore).loading,
                    condensed: "",
                    pagination: "",
                    "total-items": (0, vue_2.unref)(quotationStore).totalQuotations,
                    class: "mt-4"
                }, {
                    "cell-createdDate": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.d)(item.createdDate, "long", "hu-HU")), 1)
                    ]),
                    "cell-validationDate": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.d)(item.validationDate, "short", "hu-HU")), 1)
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item }) => [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-primary btn-link",
                            onClick: ($event) => (viewPdf(item))
                        }, [
                            _hoisted_4,
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("view_pdf", "View PDF", "quotation_list")), 1)
                        ], 8, _hoisted_3)
                    ]),
                    _: 1
                }, 8, ["fields", "currentPage", "sortBy", "sortDesc", "itemsPerPage", "items", "is-busy", "total-items"])
            ]));
        };
    }
});
